export const EMAIL_VALIDATION_CONFIG = {
  REGEX: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  SPACES_REGEX: /\s/,
} as const;

export const isValidEmail = (email: string | null | undefined): boolean => {
  if (!email || typeof email !== 'string') {
    return false;
  }

  const trimmedEmail = email.trim();
  
  if (trimmedEmail.length === 0) {
    return false;
  }

  const hasSpaces = EMAIL_VALIDATION_CONFIG.SPACES_REGEX.test(trimmedEmail);
  if (hasSpaces) {
    return false;
  }

  const parts = trimmedEmail.split('@');
  if (parts.length !== 2) {
    return false;
  }

  const [ localPart, domainPart ] = parts;
  if (!localPart || !domainPart) {
    return false;
  }

  if (!domainPart.includes('.')) {
    return false;
  }

  if (domainPart.startsWith('.') || domainPart.endsWith('.') || domainPart.includes('..')) {
    return false;
  }

  const isValidFormat = EMAIL_VALIDATION_CONFIG.REGEX.test(trimmedEmail);
  
  return isValidFormat;
};
